//natives
import React from 'react';
import Button from '@material-ui/core/Button';

export default (props, value, tableMeta, updateValue) => {
    return (
        <Button
            color="primary"
            variant={"outlined"}
            formTarget="_blank"
            size={'small'}
            onClick={()=>{
                props.checkRoute(value);
            }}
        >
            Visualizar
        </Button>
    );
};